import { init } from './Home';
init();
